import { HttpHelper } from '../../_commons/Helpers/HttpHelper';

export interface ILiveNotificationTimedSchedule{
    scheduleId:number,
    liveNotificationId:number,
    expectedRunDateTime:Date,
    actualRunDateTime:Date|null
}
export type IGetResponseData = ILiveNotificationTimedSchedule;
export type IGetAllResponseData = ILiveNotificationTimedSchedule[];
const apiRoot="/api/CMS/LiveNotificationTimeScheduleCMS"

const Get = (id: number , token: string): Promise<IGetResponseData | null> => {


    return HttpHelper.Get(`${apiRoot}/${id}`, token).then(async (resp) => {
        if (resp.status === 200) {
            let data: IGetResponseData = await resp.json();
            return data;
        } else {
            return null;
        }

    })
}
const GetAll = (liveNotificationId:number|undefined, token: string): Promise<IGetAllResponseData| null> => {


    return HttpHelper.Get(`${apiRoot}/All${liveNotificationId?`?liveNotificationId=${liveNotificationId}`:""}`, token).then(async (resp) => {
        if (resp.status === 200) {
            let data: IGetAllResponseData = await resp.json();
            return data;
        } else {
            return null;
        }

    })
}



const Update = (action: "ADD" | "EDIT", obj: ILiveNotificationTimedSchedule, token: string): Promise<boolean> => {
    console.log(obj)
    if (action === "ADD")
        return HttpHelper.PostJSON(`${apiRoot}/Add`, obj, token).then(async (resp) => {
            if (resp.status === 200)
                return true;
            else
                return false;
        })
    else
        return HttpHelper.PostJSON(`${apiRoot}/Edit`, obj, token).then(async (resp) => {
            if (resp.status === 200)
                return true;
            else
                return false;
        })
}
interface IDeleteReqModel {
    id: number
}
const Delete = (reqData: IDeleteReqModel, token: string): Promise<boolean> => {
    return HttpHelper.PostJSON(`${apiRoot}/Delete`, reqData, token).then(async (resp) => {
        if (resp.status === 200)
            return true;
        else
            return false;
    })
}





export const LiveNotificationScheduleCMSApi = {
    Get,
    GetAll,
    Update,
    Delete
}